import { render, staticRenderFns } from "./AvarageMessages.vue?vue&type=template&id=ceabab40&%23AvarageMessages=true"
import script from "./AvarageMessages.vue?vue&type=script&lang=js"
export * from "./AvarageMessages.vue?vue&type=script&lang=js"
import style0 from "./AvarageMessages.vue?vue&type=style&index=0&id=ceabab40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports